import React from 'react';
import { ShoppingBagIcon, FileTextIcon, SyringeIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
const ACTIONS = [{
  title: 'Shop Over-The-Counter',
  icon: <ShoppingBagIcon className="w-6 h-6" data-id="element-255" />,
  link: '/otc-products',
  image: 'https://images.unsplash.com/photo-1586015555751-63bb77f4322a?q=80&w=800&auto=format&fit=crop'
}, {
  title: 'Transfer Your Prescription',
  icon: <FileTextIcon className="w-6 h-6" data-id="element-256" />,
  link: '/transfer-prescription',
  image: 'https://images.unsplash.com/photo-1587854692152-cbe660dbbb88?q=80&w=800&auto=format&fit=crop'
}, {
  title: 'Check Vaccine Availability',
  icon: <SyringeIcon className="w-6 h-6" data-id="element-257" />,
  link: '/immunizations',
  image: 'https://images.unsplash.com/photo-1632345031435-8727f6897d53?q=80&w=800&auto=format&fit=crop'
}];
export function QuickActions() {
  return <section className="py-12 sm:py-16 bg-clean-grey" data-id="element-258">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-259">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-lg sm:text-xl font-bold text-slate-900 mb-8 sm:mb-10 text-center uppercase tracking-widest" data-id="element-260">
          What would you like to do today?
        </motion.h2>
        <div className="grid md:grid-cols-3 gap-4 sm:gap-6" data-id="element-261">
          {ACTIONS.map((action, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} data-id="element-262">
              <Link to={action.link} className="bg-white rounded-xl border border-slate-200 flex flex-col items-center text-center hover:shadow-md transition-shadow cursor-pointer group h-full overflow-hidden" data-id="element-263">
                <div className="w-full aspect-[16/9] overflow-hidden" data-id="element-264">
                  <img src={action.image} alt={action.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" onError={e => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = 'https://cdn.magicpatterns.com/uploads/xdNDKr9wN59hCtzteEJdbE/pasted-image.jpg';
              }} data-id="element-265" />
                </div>
                <div className="p-6 sm:p-10 flex flex-col items-center" data-id="element-266">
                  <div className="text-clinical-blue mb-4 sm:mb-6 group-hover:scale-110 transition-transform" data-id="element-267">
                    {action.icon}
                  </div>
                  <h3 className="text-sm font-bold text-slate-900 uppercase tracking-wide" data-id="element-268">
                    {action.title}
                  </h3>
                </div>
              </Link>
            </motion.div>)}
        </div>
      </div>
    </section>;
}